import { normalizeImagePaint, type ImageFillMode, type ImagePaint } from "@/document/model/styles";
import type { Rect } from "@/lib/math/rect";

export function imageRectForPaint(bounds: Rect, paint: ImagePaint): Rect {
  const normalized = normalizeImagePaint(paint);
  if (normalized.fillMode === "crop") {
    return {
      x: bounds.x + normalized.crop.x * bounds.width,
      y: bounds.y + normalized.crop.y * bounds.height,
      width: normalized.crop.width * bounds.width,
      height: normalized.crop.height * bounds.height,
    };
  }

  return fittedImageRect(bounds, normalized.intrinsicWidth / normalized.intrinsicHeight, normalized.fillMode);
}

export function rectToNormalizedCrop(bounds: Rect, rect: Rect): ImagePaint["crop"] {
  return {
    x: bounds.width === 0 ? 0 : (rect.x - bounds.x) / bounds.width,
    y: bounds.height === 0 ? 0 : (rect.y - bounds.y) / bounds.height,
    width: bounds.width === 0 ? 1 : rect.width / bounds.width,
    height: bounds.height === 0 ? 1 : rect.height / bounds.height,
  };
}

function fittedImageRect(bounds: Rect, aspectRatio: number, mode: Exclude<ImageFillMode, "crop">): Rect {
  const boundsRatio = Math.abs(bounds.width) / Math.max(0.0001, Math.abs(bounds.height));
  const useWidth = mode === "fit" ? boundsRatio <= aspectRatio : boundsRatio >= aspectRatio;
  const width = useWidth ? bounds.width : bounds.height * aspectRatio;
  const height = useWidth ? bounds.width / aspectRatio : bounds.height;
  return {
    x: bounds.x + (bounds.width - width) / 2,
    y: bounds.y + (bounds.height - height) / 2,
    width,
    height,
  };
}
